
    import _ from 'underscore';
    import { format, parse } from 'date-fns';
    import { ru } from 'date-fns/locale';

    import {
        computed,
        defineComponent,
        PropType,
        toRefs,
        unref,
    } from 'vue';
    import ButtonDesktop from '@ve/components/button/desktop/Button.vue';
    import { DatesAndPrices } from '../common/types/IMapForDatesTabsStore';

    export default defineComponent({
        name: 'BestPriceGoTo',
        components: {
            ButtonDesktop,
        },
        props: {
            bestPriceDate: {
                type: String,
                required: false,
            },
            datesAndPrices: {
                type: Object as PropType<DatesAndPrices>,
                required: true,
            },
            pageNumber: {
                type: Number,
                required: true,
            },
            itemsVisibleCount: {
                type: Number,
                required: false,
            },
            maxPages: {
                type: Number,
                required: true,
            },
        },
        setup(props, { emit }) {
            const {
                bestPriceDate,
                datesAndPrices,
                pageNumber,
                itemsVisibleCount,
                maxPages,
            } = toRefs(props);

            const bestPriceDateFormatted = computed(() => (unref(bestPriceDate) ? format(parse(unref(bestPriceDate), 'yyyy-MM-dd', new Date()), 'd MMMM', { locale: ru }) : null));
            const bestPriceDateIndex = computed(() => _.findIndex(Object.values(unref(datesAndPrices)), (date) => date.startDate === unref(bestPriceDate)));

            const bestPriceDateGoToVisible = computed(() => {
                const bestPriceDateValue = unref(bestPriceDate);
                if (!bestPriceDateValue) return false;
                const bestPriceDateIndexValue = unref(bestPriceDateIndex);
                const pageNumberValue = unref(pageNumber);
                const itemsVisibleCountValue = unref(itemsVisibleCount);

                return bestPriceDateIndexValue >= 0 && itemsVisibleCountValue && (pageNumberValue > bestPriceDateIndexValue || (pageNumberValue + itemsVisibleCountValue - 1) < bestPriceDateIndexValue);
            });

            const bestPriceDateDirection = computed(() => {
                if (!unref(bestPriceDateGoToVisible)) return null;
                return unref(pageNumber) > unref(bestPriceDateIndex) ? 'left' : 'right';
            });

            const goBestPrice = () => {
                const itemsVisibleCountValue = unref(itemsVisibleCount);
                if (!unref(bestPriceDateGoToVisible) || !itemsVisibleCountValue) return;

                const centerOffset = Math.floor(itemsVisibleCountValue / 2);
                const bestPriceDateIndexValue = unref(bestPriceDateIndex);
                let needPageNumber;

                if (bestPriceDateIndexValue - centerOffset > unref(maxPages)) {
                    needPageNumber = unref(maxPages);
                } else if (bestPriceDateIndexValue - centerOffset < 0) {
                    needPageNumber = 0;
                } else {
                    needPageNumber = bestPriceDateIndexValue - centerOffset;
                }
                emit('go-to-best-price', {
                    pageNumber: needPageNumber,
                    date: unref(bestPriceDate),
                });
            };

            return {
                bestPriceDateGoToVisible,
                goBestPrice,
                bestPriceDateFormatted,
                bestPriceDateDirection,
            };
        },
    });
